import { CSSObject } from '@chakra-ui/react';

export const FlexResponsibleGamblingBannerWrapper: CSSObject = {
  pt: 0,
};
